import React, { useState, useEffect } from 'react';
import '../styles/Navigation.css';
import Radio from './Radio';

const Navigation = ({ activeSection }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { id: 'home', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'education', label: 'Education' },
    { id: 'experience', label: 'Experience' },
    { id: 'projects', label: 'Projects' },
    { id: 'skills', label: 'Skills' },
    { id: 'contact', label: 'Contact' },
  ];

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  const radioOptions = [
    { 
      label: 'Home', 
      prefix: '_',
      glitchText: '_Home🏠',
      number: 'h1',
      value: 'home',
      defaultChecked: true
    },
    { 
      label: 'About', 
      prefix: '_',
      glitchText: '_About_',
      number: 'a2',
      value: 'about',
      defaultChecked: false
    },
    { 
      label: 'Education', 
      glitchText: 'Edu🎓',
      number: 'e3',
      value: 'education',
      defaultChecked: false
    },
    { 
      label: 'Experience', 
      prefix: '_',
      glitchText: '_Exp💼',
      number: 'x4',
      value: 'experience',
      defaultChecked: false
    },
    { 
      label: 'Work', 
      glitchText: 'Work_',
      number: 'w5',
      value: 'projects',
      defaultChecked: false
    },
    { 
      label: 'Skills', 
      prefix: '_',
      glitchText: '_Skills⚡',
      number: 's6',
      value: 'skills',
      defaultChecked: false
    },
    { 
      label: 'Contact', 
      glitchText: 'Contact_',
      number: 'c7',
      value: 'contact',
      defaultChecked: false
    }
  ];

  const handleRadioChange = (value) => {
    scrollToSection(value);
  };

  return (
    <nav className={`navigation ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo">
          <span className="logo-text">Portfolio Showcase
          </span>
        </div>

        <div className="nav-radio">
          <Radio options={radioOptions} name="nav-sections" onChange={handleRadioChange} />
        </div>

        <button 
          className={`nav-toggle ${menuOpen ? 'active' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          {navItems.map((item, index) => (
            <li 
              key={item.id} 
              className="nav-item" 
              style={{ '--i': index }}
            >
              <a
                href={`#${item.id}`}
                className={`nav-link ${activeSection === item.id ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(item.id);
                }}
              >
                <span className="nav-text">{item.label}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
